import Logo from "../shared/logo";
import { Link } from "react-router-dom";
import { IconEnvelope, IconTG, IconVK } from "../icons";

const topFooterLinkArray = [
  {
    href: "/feedback",
    label: "Отзывы",
    colSpan: 2,
    key: "2",
  },
  {
    href: "/parents",
    label: "Родителям",
    colSpan: 3,
    key: "3",
  },
  {
    href: "/achievements",
    label: "Достижения",
    colSpan: 3,
    key: "4",
  },
  {
    href: "/our-team",
    label: "Команда",
    colSpan: 2,
    key: "5",
  },
  {
    href: "/articles",
    label: "Статьи",
    colSpan: 2,
    key: "6",
  },
  {
    href: "/theagreementofaccession",
    label: "Договор присоединения",
    colSpan: 2,
    key: "7",
  },
];

export function Footer() {
  if (window.location.pathname.startsWith("/print")) {
    return <></>; // Hide menu on print pages
  }
  return (
    <div className="Footer">
      <div className="FooterMainContainer">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Logo className="DisappearingLogo" />
          <div className="FooterContainer">
            {topFooterLinkArray.map((labelLink) => (
              <a
                className="FooterLinkText"
                href={labelLink.href}
                key={labelLink.label}
              >
                {labelLink.label}
              </a>
            ))}
          </div>
        </div>

        <hr
          style={{
            border: "1px solid",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        />
        <div className="FooterContainer">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <a className="FooterLinkText2" href={"/"}>
              {" "}
              Уроки с преподавателем
            </a>

            <Link className="FooterLinkText" to={"/fefelova"}>
              Фефелова Ольга
            </Link>

            <div>
              <IconTG bw={false} />
              <a className="FooterLinkText" href="https://t.me/Fefelova_OM">
                {" "}
                +7 (981) 682-86-83
              </a>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <a className="FooterLinkText2" href={"/"}>
              Задайте вопросы
            </a>

            <div>
              <IconEnvelope bw={false} />
              <a href="mailto:minimath239@yandex.ru" className="FooterLinkText">
                {" "}
                minimath239@yandex.ru
              </a>
            </div>

            <div
              style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}
            >
              <IconVK />
            </div>
          </div>
        </div>

        <hr
          style={{
            border: "1px solid",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        />
        <div className="FooterContainer">
          <div className="FooterPlinkDisabled">
            2018-2026 | Fefelova School, All Rights Reserved
          </div>
          <div className="FooterPlinkDisabled">
            ИП Фефелова О.М. | ИНН 472001848681
          </div>
          <div className="FooterPlinkDisabled">
            Москва, Большая Якиманка, 26
          </div>

          <Link className="FooterPlink" to={"/privacy"}>
            Политика конфиденциальности{" "}
          </Link>
        </div>
      </div>
    </div>
  );
}
